import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../context/AppContext";
import EditableForm from "../EditableForm";
import { createProject } from "../../api/projects";

const CreateTemplateDialog = ({ open, onClose, onSuccess }) => {
    const { t } = useTranslation();
    const { setIsLoading } = useAppContext();
    const [error, setError] = useState(null);

    const [form, setForm] = useState({
        title: "",
        is_template: true,
    });

    const handleSubmit = async (data) => {
        setIsLoading(true);
        try {
            await createProject({ ...data, is_template: true });
            setError(null);
            onSuccess?.();
            setForm({ title: "", is_template: true });
            onClose();
        } catch (err) {
            console.error("Save error", err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const fields = [
        { name: "title", label: t("common.title"), required: true },
    ];

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ color: "#000" }}>{t("templates.create")}</DialogTitle>
            <DialogContent sx={{ paddingTop: "5px !important" }}>
                {error && (
                    <Box mb={2}>
                        <Box
                            sx={{
                                bgcolor: "#fdecea",
                                color: "#b71c1c",
                                px: 2,
                                py: 1.5,
                                borderRadius: 1,
                                fontSize: 14,
                                fontWeight: 500,
                            }}
                        >
                            {t(`${error}`) || error}
                        </Box>
                    </Box>
                )}
                <EditableForm
                    data={form}
                    fields={fields}
                    onChange={setForm}
                    onSubmit={handleSubmit}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    sx={{ color: "#000" }}
                >
                    {t("actions.cancel")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateTemplateDialog;
